import {getABTest, sendABTestAnalytics} from "../../domain/abtest/abtest-provider";
import {sendGAEvent} from "../../domain/marketing/gtm-provider";
import {getPersonalizationProperty} from "../personalization/domain/personalization-provider";

window.addEventListener('DOMContentLoaded', (event) => {

    //const nodeGUID = document.getElementById('nodeguid')?.textContent?.trim().toLowerCase();
    //if(nodeGUID !== '2a648dcc-c490-4886-9cfe-138c45ae35d8'){
    //    ABShow('hide');
    //    return;
    //}

    //const isUserPurhased = document.getElementById('is-user-purhased')?.textContent?.trim().toLowerCase();
    //console.log('isUserPurhased: ',isUserPurhased);
    //if(isUserPurhased !== 'false'){
    //    ABShow('hide');
    //    return;
    //}

    const abtest_SBSBannerHP = getABTest('HPHeroWCA');
    const abTestEnabled = !!abtest_SBSBannerHP && abtest_SBSBannerHP.isActive;
    if(!abTestEnabled) {
        ABShow('creative-access');
        return;
    }
    const isCorrectPersona = getPersonalizationProperty('persona') === 'wca-prospect';

    //const visitorFindMethod = document.getElementById('visitor-find-method')?.textContent?.trim().toLowerCase();
    //if(visitorFindMethod !== undefined && visitorFindMethod !== null && visitorFindMethod !== '')
    //    sendGAEvent('visitor-find-method',visitorFindMethod);
    if(isCorrectPersona) {
        sendABTestAnalytics(abtest_SBSBannerHP);
        ABShow(abtest_SBSBannerHP.selected);
    }


    function ABShow(abtestSelected : string) {
        const abCreativeAccess = document.querySelector('[data-ab="creative-access"]') as HTMLElement | null;
        const abOneSubscription = document.querySelector('[data-ab="one-subscription"]') as HTMLElement | null;
        const abTestDrive = document.querySelector('[data-ab="test-drive"]') as HTMLElement | null;
        const abAccess240 = document.querySelector('[data-ab="access-240"]') as HTMLElement | null;

        if(!abAccess240 && !abCreativeAccess && !abOneSubscription && !abTestDrive) return;

        if(abtestSelected === 'creative-access'){
            if (abCreativeAccess?.classList.contains("hidden")) {
                abCreativeAccess?.classList.remove("hidden");
            }

            if (!abOneSubscription?.classList.contains("hidden")) {
                abOneSubscription?.classList.add("hidden");
            }

            if (!abTestDrive?.classList.contains("hidden")) {
                abTestDrive?.classList.add("hidden");
            }

            if (!abAccess240?.classList.contains("hidden")) {
                abAccess240?.classList.add("hidden");
            }
        }
        if(abtestSelected === 'one-subscription'){
            if (!abCreativeAccess?.classList.contains("hidden")) {
                abCreativeAccess?.classList.remove("hidden");
            }

            if (abOneSubscription?.classList.contains("hidden")) {
                abOneSubscription?.classList.remove("hidden");
            }

            if (!abTestDrive?.classList.contains("hidden")) {
                abTestDrive?.classList.add("hidden");
            }

            if (!abAccess240?.classList.contains("hidden")) {
                abAccess240?.classList.add("hidden");
            }
        }
        if(abtestSelected === 'test-drive'){
            if (!abCreativeAccess?.classList.contains("hidden")) {
                abCreativeAccess?.classList.remove("hidden");
            }

            if (!abOneSubscription?.classList.contains("hidden")) {
                abOneSubscription?.classList.add("hidden");
            }

            if (abTestDrive?.classList.contains("hidden")) {
                abTestDrive?.classList.remove("hidden");
            }

            if (!abAccess240?.classList.contains("hidden")) {
                abAccess240?.classList.add("hidden");
            }
        }
        if(abtestSelected === 'access-240'){
            if (!abCreativeAccess?.classList.contains("hidden")) {
                abCreativeAccess?.classList.remove("hidden");
            }

            if (!abOneSubscription?.classList.contains("hidden")) {
                abOneSubscription?.classList.add("hidden");
            }

            if (!abTestDrive?.classList.contains("hidden")) {
                abTestDrive?.classList.remove("hidden");
            }

            if (abAccess240?.classList.contains("hidden")) {
                abAccess240?.classList.remove("hidden");
            }
        }
    };

});

export {};